// @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class RlNavigation {
    set(navigate, location) {
        this.navigate = navigate;
        this.location = location;
    }
    async push(u) {
        if (this.navigate) {
            this.navigate(u);
        }
    }
    path() {
        if (this.location) {
            return this.location.pathname;
        }
        return '';
    }
    constructor(){
        _define_property(this, "navigate", void 0);
        _define_property(this, "location", void 0);
    }
}
export const rlNavigation = new RlNavigation();
